import Cookie from "js-cookie";
import constants from "../values/constants";
import utils from ".";
import { ICityItem } from "../types/common.interface";
interface iProps {
  token: string;
  avatar: string;
  userId: string;
  balance: any;
  userType: string;
  fullName: string;
  city: ICityItem;
  province: string;
  permission: any;
  isPrimary: string;
  documents: {
    nationalCardFront?: string;
    nationalCardBack?: string;
    companyLicence?: string;
  };
  profitBalance: string;
}
function setLoginData({
  token,
  userType,
  userId,
  fullName,
  avatar,
  balance,
  city,
  province,
  permission,
  isPrimary,
  documents,
  profitBalance,
}: iProps) {
  Cookie.set(constants.USER.FULL_NAME, fullName, { expires: 7 });
  Cookie.set(constants.USER.IDENTIFY, userId, { expires: 7 });
  Cookie.set(constants.USER.BALANCE, balance, { expires: 7 });
  Cookie.set(constants.USER.AVATAR, avatar, { expires: 7 });
  Cookie.set(constants.USER.TOKEN, token, { expires: 7 });
  Cookie.set(constants.USER.IS_PRIMARY_ADMIN, isPrimary, { expires: 7 });
  Cookie.set(constants.USER.PROFIT_BALANCE, profitBalance, { expires: 7 });
  Cookie.set(constants.USER.FINANCIAL_PERMISSION, permission?.financial, {
    expires: 7,
  });
  Cookie.set(constants.USER.COMPANY_DOCUMENTS, JSON.stringify(documents), {
    expires: 7,
  });
  Cookie.set(constants.USER.WRITE_PERMISSION, permission?.write, {
    expires: 7,
  });
  Cookie.set("city", JSON.stringify(city), { expires: 7 });
  Cookie.set("province", JSON.stringify(province), { expires: 7 });
  Cookie.set(constants.USER.TYPE, utils.stringHexConversion.create(userType), {
    expires: 7,
  });
}
export default setLoginData;
